import { render, staticRenderFns } from "./detailsTracksView.vue?vue&type=template&id=33ec9a4a&scoped=true&"
import script from "./detailsTracksView.vue?vue&type=script&lang=js&"
export * from "./detailsTracksView.vue?vue&type=script&lang=js&"
import style0 from "./detailsTracksView.vue?vue&type=style&index=0&id=33ec9a4a&prod&lang=scss&scoped=true&"
import style1 from "./detailsTracksView.vue?vue&type=style&index=1&id=33ec9a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec9a4a",
  null
  
)

export default component.exports